import React from 'react';
import Lottie from 'lottie-react';
import { Props } from './types';
import siscobLogo from '../../../assets/logo_siscob_modal.svg';
import ChristmasTreeAnimation from '../../../assets/santaRings.json';
// import ChristmasSleighAnimation from '../../assets/ChristmasSleigh.json';
import CloseIcon from '../../../assets/close';
import {
  StyledDialog,
  Content,
  CloseWrapper,
  TextSection,
  Logo,
  Head,
  SubMsg,
  ExtraMsg,
  TreeContainer,
} from './styles';

const Welcome: React.FC<Props> = ({ closeWelcome, isOpen }) => {
  return (
    <StyledDialog
      open={isOpen}
      onClose={() => closeWelcome()}
      aria-labelledby="max-width-dialog-title"
    >
      <Content>
        <CloseWrapper>
          <CloseIcon color="#fff" click={() => closeWelcome()} />
        </CloseWrapper>

        <TextSection>
          <Logo src={siscobLogo} alt="LogoWhiteSiscob" />

          <Head>
            <span>O time do Siscob,</span>
          </Head>
          <SubMsg>Deseja a você boas festas.</SubMsg>
          <ExtraMsg>
            Que o seu Natal seja festejado com muita paz e harmonia e que o Ano
            Novo seja recebido com muita alegria.
          </ExtraMsg>
        </TextSection>
        <TreeContainer>
          <Lottie animationData={ChristmasTreeAnimation} loop />
        </TreeContainer>
      </Content>
    </StyledDialog>
  );
};

export default Welcome;
